import SocialIcons from './SocialIcons';

export default SocialIcons;


// WEBPACK FOOTER //
// ./src/components/SocialIcons/index.js